(function($){
    if($('body.single-product .entry-summary p.price').length > 0){
        var prodid, type;
        if($('form.variations_form.cart').length > 0){
            prodid = $('[name="product_id"]').val();
            type = 'variable';
        }
        else{
            prodid = $('.single_add_to_cart_button').val()
            type = 'normal';
        }
        load_legia_price(prodid, type);
    }

    function load_legia_price(prodid, type) {
        $.ajax({
            url: script.ajax_url,
            method: 'post',
            data: {
                'action': 'load_legia_price',
                'prodid': prodid,
                'type': type,
                'nonce': script.nonce
            },
            beforeSend: function beforeSend() {

            },
            success: function success(data) {
                $('body.single-product .entry-summary p.price').html(data);
                $('body.single-product .entry-summary p.price').addClass('loaded');
            },
            error: function error(errorThrown) {
                console.log(errorThrown);
            }
        });
    }

})(jQuery)